import { useMediaQuery } from '@mui/material'

export const useMQ = () => {
  const xs = 460
  const sm = 600
  const md = 900
  const lg = 1200
  const isBelowXsSize = useMediaQuery(`(max-width:${xs}px)`)
  const isXsSize = useMediaQuery(`(max-width:${sm}px)`)
  const isSmSize = useMediaQuery(`(max-width:${md}px)`)
  const isMdSize = useMediaQuery(`(max-width:${lg}px)`)
  const isBelowLgSize = useMediaQuery(`(max-width:${lg}px)`)
  const isLgSize = useMediaQuery(`(min-width:${lg}px)`)
  const isBelow900 = useMediaQuery(`(max-width:900px)`)
  const isBelow1200 = useMediaQuery(`(max-width:1200px)`)

  return {
    isXsSize,
    isSmSize,
    isMdSize,
    isLgSize,
    isBelowXsSize,
    isBelowLgSize,
    isBelow900,
    isBelow1200,
  }
}
